import { InertiaLink } from '@inertiajs/inertia-react'
import React, { useState } from 'react'
import LandingLayout from '@/Layouts/LandingLayout'
import { Container } from '@/Components/Container'
import { FormError } from '@/Components/FormError'
import { Video } from '@/Components/Video'
import { Inertia } from '@inertiajs/inertia'
import { useTitle } from '@/Utilities/Hooks'
import { Input } from '@/Components/Form'
import {SuccessMessage} from "@/Components/Messages";

export default function Register({ errors, flash }) {
  useTitle('Registration')

  let [firstname, setFirstname] = useState('')
  let [surname, setSurname] = useState('')
  let [email, setEmail] = useState('')
  let [phone, setPhone] = useState('')
  let [disableForm, setDisableform] = useState(false)

  function handleRegister(e) {
    e.preventDefault()
    if (disableForm) return false;
    setDisableform(true);

    // > Fortify: The /register endpoint expects a string name, string email address / username, password, and password_confirmation fields.
    // > The name of the email / username field should match the username configuration value defined within your application's fortify configuration file.

    // Using a custom endpoint and not fortify for registration since this is not the step we currently create users
    // Inertia.post('/requestAccount', { firstname, surname, email, phone })
    Inertia.post('/sendConfirmation', { firstname, surname, email, phone })
  }

  return (
    <Container size="flex flex-col md:flex-row flex-wrap max-w-5xl bg-white self-center xl:dots-topright xl:dots-bottomleft overflow-visible relative p-4 md:p-8 lg:p-16 md:mt-10">
      <div className="flex flex-row flex-wrap justify-start w-full md:w-2/3 md:pr-6">
        <div className="flex flex-col items-start">
          <a href="https://gidas.se">
            <img
              className="self-start w-16 h-16 mb-8"
              src="/images/logo_dark.png"
              alt="Gidås logo"
            />
          </a>
          <h1 className="header-1">Send in your request for an account</h1>
          <p>Fill out your contact information and we will help you get started on your emission accounting.</p>
        </div>
        <form onSubmit={handleRegister}>
          <div className="flex flex-row flex-wrap justify-between pt-10">
            {flash.status && (
              <SuccessMessage>{flash.status}</SuccessMessage>
            )}
            <FormError className="mb-2" error={errors.apierror} />
            <div className="w-full mb-4 md:w-1/2">
              <label>
                <span className="block pr-4 mb-1">First name</span>
                <Input
                  autoFocus
                  disabled={disableForm}
                  name="firstname"
                  type="text"
                  placeholder="Enter first name"
                  value={firstname}
                  onChange={e => setFirstname(e.target.value)}
                />
              </label>
              <FormError error={errors.firstname} />
            </div>
            <div className="w-full mb-4 md:w-1/2 md:pl-4">
              <label>
                <span className="block mb-1">Surname</span>
                <Input
                  disabled={disableForm}
                  name="surname"
                  type="text"
                  placeholder="Enter surname"
                  value={surname}
                  onChange={e => setSurname(e.target.value)}
                />
              </label>
              <FormError error={errors.surname} />
            </div>
            <div className="w-full mb-4">
              <label>
                <span className="block mb-1">E-mail</span>
                <Input
                  disabled={disableForm}
                  name="email"
                  type="email"
                  placeholder="Enter e-mail"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </label>
              <FormError error={errors.email} />
            </div>
            <div className="w-full mb-4">
              <label>
                <span className="block mb-1">Phone number</span>
                <Input
                  disabled={disableForm}
                  name="phone"
                  type="tel"
                  placeholder="Enter phone number"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </label>
              <FormError error={errors.phone} />
            </div>
            <div className="flex flex-row justify-between w-full">
              <div className="flex-shrink pr-4">
                <p>
                    By clicking "Send Request", I agree to Gidås <InertiaLink className="underline hover:no-underline" href="/terms-of-service">Terms of Service</InertiaLink>
                </p>
              </div>
              <div className="flex-shrink-0">
                <button
                  disabled={disableForm}
                  className="px-6 py-2 ml-4 text-white bg-blue hover:bg-blue-light active:bg-teal-700"
                >
                  Send request
                </button>
              </div>
            </div>
          </div>
        </form>
        <p className="w-full p-3 my-12 text-left bg-primary-light">
          <span className="font-bold">Already have an account?</span> <InertiaLink className="underline hover:no-underline" href="/login">Sign in here</InertiaLink>
        </p>
      </div>
      <div className="flex flex-col self-center w-full pt-6 md:w-1/3 md:pl-6">
        <Video video="sign_up"></Video>
      </div>
    </Container>
  )
}

Register.layout = page => (
  <LandingLayout>{page}</LandingLayout>
)
